import React from 'react';
import { useNavigate } from 'react-router-dom';
import OrderTracking from '../components/OrderTracking';

const OrderTrackPage = () => {
  const navigate = useNavigate();
  return <OrderTracking onBack={() => navigate(-1)} />;
};

export default OrderTrackPage;
